<div>
    <app-dealer-search>

    </app-dealer-search>
</div>
